const experienceData=[
  {
    date: '24.10~25.03',
    title: '웹 퍼블리셔 전문가 양성 과정 수료',
    dec: '스킬 향상을 위해 리액트 및 뷰 기반의 프론트 웹 퍼블리셔 과정을 공부했습니다.'
  },
  {
    date: '22.05~24.08',
    title: '한샘스토어 온라인팀',
    dec: 'MD와 협업하여 한샘의왕점 자체 온라인몰의 상세 페이지와 배너 작업을 담당했습니다.'
  },
  {
    date: '21.12~22.03',
    title: '팜네이트 유통사업부',
    dec: '소작농의 온라인 진출을 돕는 사업으로, 현장을 직접 방문하고 농작물에 대해 스스로 공부하며 디자인 작업을 진행했습니다.'
  },
  {
    date: '21.03~21.10',
    title: '송월타올앤리빙 웹디자인팀',
    dec: '타올을 직접 촬영 및 보정하여 상세 페이지를 만드는 작업이 주 업무였습니다.'
  },
  {
    date: '20.11~21.02',
    title: '영상편집 유튜브 크리에이터 과정 수료',
    dec: '웹디자인 역량 강화를 위해 어도비 프리미어를 학습하고, 영상 편집 기술을 익혔습니다.'
  },
  {
    date: '19.03~20.07',
    title: '넥스리치 IT부',
    dec: '퍼블리셔 및 개발자와 협업하여 자사몰 구축을 위한 웹 및 모바일 디자인 작업을 수행했습니다.'
  },
];

export default experienceData;